import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DialogBaseComponent } from './dialog-base.component';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent extends DialogBaseComponent {

}
